module.exports = __webpack_public_path__ + "static/img/term_library.09f33a6f.gif";